import { textFontVariablesClassName } from "@/lib/textFontsLoader";
import "@/styles/globals.css";
import type { AppProps } from "next/app";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <div className={textFontVariablesClassName}>
      <Component {...pageProps} />
    </div>
  );
}
